export default class PlayerList {
    static init(): void {
        // Najdeme všechny player-list-item elementy
        const playerItems: NodeListOf<Element> = document.querySelectorAll('.player-list-item');
        // Najdeme cílový element pro obrázek
        const playerListImg: Element | null = document.querySelector('.js-player-list-img');
        const imgElement: HTMLImageElement | null = playerListImg ? playerListImg.querySelector('img') : null;
        // Najdeme kontejner pro sticky positioning
        const playerListInner: Element | null = document.querySelector('.player-list__inner');
        // Najdeme navbar pro výpočet offsetu
        const navbar: Element | null = document.querySelector('.base-navbar');

        // Pokud nejsou nalezeny potřebné elementy, ukončíme
        if (!playerItems.length || !playerListImg || !imgElement || !playerListInner) {
            //console.warn('Player list elements not found');
            return;
        }

        // Funkce pro sticky positioning
        const handleScroll = (): void => {
            // Kontrola, zda je element viditelný (pro řešení tabů)
            const isVisible = (playerListInner as HTMLElement).offsetParent !== null;
            if (!isVisible) {
                return;
            }

            const navbarHeight: number = navbar ? navbar.getBoundingClientRect().height : 0;
            const innerRect: DOMRect = playerListInner.getBoundingClientRect();
            const imgRect: DOMRect = playerListImg.getBoundingClientRect();

            // Vypočítáme pozice
            const stickyTop: number = navbarHeight;
            const containerTop: number = innerRect.top;
            const containerBottom: number = innerRect.bottom;

            // Odebereme všechny sticky třídy
            playerListImg.classList.remove('is-sticky', 'is-sticky-bottom');

            // Nastavíme CSS custom properties pro pozici
            (playerListImg as HTMLElement).style.setProperty('--navbar-height', `${navbarHeight}px`);
            (playerListImg as HTMLElement).style.setProperty(
                '--container-right',
                `${window.innerWidth - innerRect.right}px`,
            );
            (playerListImg as HTMLElement).style.setProperty('--container-width', `${innerRect.width}px`);

            // Kontrola, zda je potřeba sticky positioning
            if (containerTop <= stickyTop && containerBottom > stickyTop + imgRect.height) {
                // Element by měl být sticky
                playerListImg.classList.add('is-sticky');
            } else if (containerBottom <= stickyTop + imgRect.height) {
                // Element by měl být na spodku kontejneru
                playerListImg.classList.add('is-sticky-bottom');
            }
            // Jinak zůstává v normální pozici (bez tříd)
        };

        // Observer pro změny viditelnosti (např. při přepínání tabů)
        const observerCallback = (mutations: MutationRecord[]): void => {
            mutations.forEach((mutation) => {
                if (
                    mutation.type === 'attributes' &&
                    (mutation.attributeName === 'style' || mutation.attributeName === 'class')
                ) {
                    // Malé zpoždění pro stabilní měření
                    setTimeout(handleScroll, 10);
                }
            });
        };

        // Vytvoříme observer pro sledování změn
        const observer = new MutationObserver(observerCallback);

        // Najdeme nejbližší tab kontejner
        const tabContainer =
            (playerListInner as HTMLElement).closest('[style*="display"], .tab-content, .tab-pane') ||
            (playerListInner as HTMLElement).closest('div');

        if (tabContainer) {
            observer.observe(tabContainer, {
                attributes: true,
                attributeFilter: ['style', 'class'],
                subtree: true,
            });
        }

        // Přidáme scroll listener
        window.addEventListener('scroll', handleScroll);

        // Přidáme resize listener pro případné změny velikosti
        window.addEventListener('resize', handleScroll);

        // Spustíme při inicializaci s malým zpožděním
        setTimeout(handleScroll, 100);

        // Pro každý player-list-item přidáme event listenery
        playerItems.forEach((item: Element) => {
            // Mouseenter event - při najetí myší
            item.addEventListener('mouseenter', () => {
                // Přidáme třídu is-active
                playerListImg.classList.add('is-active');

                // Získáme cestu k obrázku z data atributu
                const playerImgPath: string | null = item.getAttribute('data-player-img');

                // Nastavíme src obrázku
                if (playerImgPath) {
                    imgElement.src = playerImgPath;
                }
            });

            // Mouseleave event - při opuštění myší
            item.addEventListener('mouseleave', () => {
                // Odebereme třídu is-active
                playerListImg.classList.remove('is-active');

                // Vyprázdníme src obrázku
                imgElement.src = '';
            });
        });
    }

    // Veřejná metoda pro refresh pozice (pro volání z tab systému)
    static refresh(): void {
        // Najdeme element a zavoláme handleScroll
        const playerListInner = document.querySelector('.player-list__inner');
        if (playerListInner) {
            // Simulujeme scroll event
            window.dispatchEvent(new Event('scroll'));
        }
    }
}
